import React from 'react';
import PropTypes from 'prop-types';
import {kebabCase} from 'lodash';
import moment from 'moment';

import {Dropdown, DropdownItem, Select, Option, Icon} from '@albert-io/atomic';

import AuthorDashboardMetricsCustomDate from './AuthorDashboardMetricsCustomDate.react';

const thisYear = moment()
  .startOf('year')
  .format('YYYY');
const lastYear = moment()
  .subtract(1, 'years')
  .format('YYYY');

const Trigger = (value) => (
  <button className='author-dashboard-metrics__subjects-dropdown'>
    <div className='author-dashboard-metrics__subject-value'>
      {value}
      <Icon icon='caret-down' className='author-dashboard-metrics__subject-value-icon' />
    </div>
  </button>
);

const subjectDropdownLabel = (selectedSubjects, publishedSubjects) => {
  if (selectedSubjects.size === publishedSubjects.size) {
    return <div>All Subjects</div>;
  }
  if (selectedSubjects.size === 1) {
    return <div>{selectedSubjects.first()}</div>;
  }
  if (selectedSubjects === null) {
    return <div>0 Subjects</div>;
  }
  return <div>{`${selectedSubjects.size} Subjects`}</div>;
};

class AuthorDashboardMetricsDropdowns extends React.Component {
  static propTypes = {
    data: PropTypes.object
  };

  state = {
    isCustomDate: false
  };

  handleDropdownChange = (e) => {
    if (e.target.value === 'Custom') {
      this.setState({isCustomDate: true});
    }
    this.props.data.handleDateChange(e);
    if (this.state.isCustomDate) {
      this.setState({isCustomDate: false});
    }
  };

  render() {
    const {
      handleSubjectSelection,
      publishedSubjects,
      selectedSubjects,
      storeCustomStartDate,
      storeCustomEndDate,
      startDate,
      endDate,
      selectValue
    } = this.props.data;
    return (
      <div className='author-dashboard-metrics__dropdown-container'>
        <div className='author-dashboard-metrics__top-dropdown-container'>
          <div className='author-dashboard-metrics__dropdown author-dashboard-metrics__first-dropdown'>
            <Dropdown
              fillWrapper
              position='bottom'
              trigger={Trigger(subjectDropdownLabel(selectedSubjects, publishedSubjects))}
            >
              {publishedSubjects.map((subject, idx) => {
                return (
                  <DropdownItem
                    checked={selectedSubjects.includes(subject)}
                    value={kebabCase(subject.toLowerCase())}
                    key={idx}
                    onCheckboxChange={(e) => handleSubjectSelection(e, idx)}
                  >
                    {subject}
                  </DropdownItem>
                );
              })}
            </Dropdown>
          </div>
          <div className='author-dashboard-metrics__dropdown'>
            <Select
              fillWrapper
              size='s'
              border
              onChange={this.handleDropdownChange}
              value={selectValue}
            >
              <Option value='this-year' label={`In ${thisYear}`} />
              <Option value='last-year' label={`In ${lastYear}`} />
              <Option value='Custom' label='Custom' />
            </Select>
          </div>
        </div>
        {this.state.isCustomDate && (
          <div className='author-dashboard-metrics__dropdown-custom'>
            <AuthorDashboardMetricsCustomDate
              storeCustomStartDate={storeCustomStartDate}
              storeCustomEndDate={storeCustomEndDate}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        )}
      </div>
    );
  }
}

export default AuthorDashboardMetricsDropdowns;
